import { fetchWithToken } from "../../interceptors/fetchInterceptor";

import {
  GET_BOATS_REG_INFO,
  ADD_NEW_ENGINE_CHECK,
  ADD_NEW_SPEC_MARK_APP,
  DELETE_NEW_NOTE_APP,
  ADD_NEW_STATEMENT_DATA,
  ADD_NEW_DEAL,
  SET_DATA_FOR_STATEMENT_TABLES,
  ADD_NEW_STATEMENT,
  CLEAR_NEW_STATEMENT,
  GET_BOATS_DECISION_INFO,
  CLEAR_DECISION_DATA,
  ADD_NEW_ENGINE_CHECK_STATIC,
  CLEAR_ENGINES_TABLE,
} from "../types";

import {
  MAIN_URL,
  PORT,
  API_ADD_NEW_ENGINE_CHECK,
  API_ADD_NEW_STATEMENT,
  API_GET_BOATS_REG_INFO,
  API_GET_BOATS_REG_ENG,
  API_GET_BOATS_REG_DEALS,
  API_GET_BOATS_REG_SPEC_MARKS,
  API_GET_BOATS_DECISION_INFO,
  API_GET_BOAT_CARD_FOR_MODIF,
} from "../../constants/constants";

import {
  setOptionsInterestedPerson,
  setOptionsRepresentPerson,
} from "../../components/AdministrativeProcedures/appBoatRegistrationRHF/optionsAppBoatRegistrationRHF";

export function getBoatRegInfo(id) {
  return async (dispatch) => {
    const requestData = await fetchWithToken(MAIN_URL + PORT + API_GET_BOATS_REG_INFO + id);
    const requestEngines = await fetchWithToken(MAIN_URL + PORT + API_GET_BOATS_REG_ENG + id);
    const requestDeals = await fetchWithToken(MAIN_URL + PORT + API_GET_BOATS_REG_DEALS + id);
    const requestSpecMarks = await fetchWithToken(MAIN_URL + PORT + API_GET_BOATS_REG_SPEC_MARKS + id);
    const dataApp = await requestData.json();
    const dataAppEng = await requestEngines.json();
    const dataAppDeals = await requestDeals.json();
    const dataAppSpecMarks = await requestSpecMarks.json();
    dataApp.docDateIssue = !!dataApp.docDateIssue ? dataApp.docDateIssue.slice(0, 10) : null;
    dataApp.docType = !!dataApp.docType ? dataApp.docType.dtcode : null;
    dataApp.kv === 0 ? (dataApp.kv = null) : (dataApp.kv = dataApp.kv);
    dataApp.agent = !!Object.entries(dataApp).find((item) => item[0].includes("agent") && !!item[1]);
    dataApp.agentDocDate = !!dataApp.agentDocDate ? dataApp.agentDocDate.slice(0, 10) : null;
    dataApp.agentDocType = !!dataApp.agentDocType ? dataApp.agentDocType.dtcode : null;
    dataApp.agentKv === 0 ? (dataApp.agentKv = null) : (dataApp.agentKv = dataApp.agentKv);
    dataApp.boatType = !!dataApp.boatType ? dataApp.boatType.btcode : null;
    dataApp.bodyMaterial = !!dataApp.bodyMaterial ? dataApp.bodyMaterial.matcode : null;
    dataApp.boatVid = !!dataApp.boatVid ? dataApp.boatVid.id : null;
    dataApp.saCategory = !!dataApp.saCategory ? dataApp.saCategory.sacCode : null;
    if (dataApp.fileDoc || dataApp.filePdf) {
      dataApp.appFileId = dataApp.fileDoc.docid || dataApp.filePdf.docid;
      dataApp.viewFileName = dataApp.fileDoc.docname || dataApp.filePdf.docname;
    }
    dataApp.fileType = dataApp.fileDoc ? "fileDoc" : dataApp.filePdf ? "filePdf" : "";
    dataApp.inspector = dataApp.inspector.userid || undefined;
    if (requestData.ok) {
      const jsonData = {
        dataApp: dataApp,
        dataAppEng: dataAppEng[0].engineList,
        dataAppEngStatic: dataAppEng[0].staticEngineList,
        dataAppDeals: dataAppDeals,
        dataAppSpecMarks: dataAppSpecMarks,
      };
      dispatch({
        type: GET_BOATS_REG_INFO,
        data: jsonData,
      });
    }
  };
}

export function getDecisionCardInfo(id) {
  return async (dispatch) => {
    const request = await fetchWithToken(MAIN_URL + PORT + API_GET_BOATS_DECISION_INFO + id);

    if (request.status === 200) {
      const response = await request.json();
      response.fio = response.fio || response.nameLe;
      const dataAppEng = response.boatCardAppEngDtoList;
      const dataAppEngStatic = response.boatCardAppEngStaticDtoList;
      const dataAppDeals = response.boatCardAppDealDtoList;
      const dataAppSpecMarks = response.boatCardAppSmDtoList;

      const jsonData = {
        data: response,
        dataAppEng: dataAppEng,
        dataAppEngStatic: dataAppEngStatic,
        dataAppDeals: dataAppDeals,
        dataAppSpecMarks: dataAppSpecMarks,
      };
      dispatch({
        type: GET_BOATS_DECISION_INFO,
        data: jsonData,
      });
    }
  };
}

export function addNewEngineCheck(newEngine, tableKey) {
  switch (true) {
    case tableKey === "boatCardAppEngDtoList":
      return {
        type: ADD_NEW_ENGINE_CHECK,
        data: newEngine,
      };
    case tableKey === "boatCardAppEngStaticDtoList":
      return {
        type: ADD_NEW_ENGINE_CHECK_STATIC,
        data: newEngine,
      };
    default:
      break;
  }
}
export function setDataForTable(data) {
  return {
    type: SET_DATA_FOR_STATEMENT_TABLES,
    data: data,
  };
}

export function addNewSpecMarkApp(newMark) {
  return {
    type: ADD_NEW_SPEC_MARK_APP,
    data: newMark,
  };
}

export function deleteNewNote(data) {
  return {
    type: DELETE_NEW_NOTE_APP,
    data: data,
  };
}
export function addNewDealApp(newDeal) {
  return {
    type: ADD_NEW_DEAL,
    data: newDeal,
  };
}
export function addNewStatementData(data) {
  return {
    type: ADD_NEW_STATEMENT_DATA,
    data: data,
  };
}

export function addNewStatement(data) {
  return async (dispatch) => {
    const request = await fetchWithToken(MAIN_URL + PORT + API_ADD_NEW_STATEMENT, {
      method: "POST",
      body: data,
    });
    const response = await request.json();
    dispatch({
      type: ADD_NEW_STATEMENT,
      data: response,
    });
  };
}

export function clearNewStatement() {
  return {
    type: CLEAR_NEW_STATEMENT,
    data: {},
  };
}

export function clearDecisionData() {
  return {
    type: CLEAR_DECISION_DATA,
    data: {},
  };
}

export function clearEnginesTable(type) {
  return {
    type: CLEAR_ENGINES_TABLE,
    data: type,
  };
}

export function addNewStatementDataRHF(id) {
  return async (dispatch) => {
    const responseBoatCard = await fetchWithToken(MAIN_URL + PORT + API_GET_BOAT_CARD_FOR_MODIF + String(id));

    let dataBoatCard = await responseBoatCard.json();
    dataBoatCard.stranId = "Республика Беларусь";
    dataBoatCard.docType = { value: dataBoatCard.docType };
    dataBoatCard.gorodId = { value: dataBoatCard.gorodId };
    dataBoatCard.oblId = { value: dataBoatCard.oblId };
    dataBoatCard.rayonId = { value: dataBoatCard.rayonId };

    dispatch({
      type: ADD_NEW_STATEMENT_DATA,
      data: dataBoatCard,
    });
  };
}
